export class SuddenDeathPlayer {
    constructor(name, numberOfRounds) {
        this.rounds = [];
        this.name = name;
        for (let i = 1; i <= numberOfRounds; i++) {
            this.rounds.push(new SuddenDeathPlayerRound(i, null));
        }
    }
}
export class SuddenDeathPlayerRound {
    constructor(round, score) {
        this.round = round;
        this.score = score;
    }
}
export class SuddenDeathHistoryEvent {
    constructor(type, round, score, eliminated, playerIndex) {
        this.type = type;
        this.round = round;
        this.score = score;
        this.eliminated = eliminated;
        this.playerIndex = playerIndex;
    }
}
